<script>
import baseMixin from '@/mixins/baseMixin'
import dayjs from '@/services/date/index'

export default {
  name: 'ClientGroupOverviewDateFilter',
  mixins: [baseMixin],
  props: {
    filterDate: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
    },
  },
  data: () => {
    return {
      datePickerMenu: false,
      y: 0,
      x: 0,
    }
  },
  methods: {
    show(e) {
      e.preventDefault()
      this.datePickerMenu = false
      this.x = e.clientX
      this.y = e.clientY
      this.$nextTick(() => {
        this.datePickerMenu = true
      })
    },
    validDateRule(v) {
      return (!!v && dayjs(v).isValid()) || this.$t('input.validDate')
    },
    handleDateUpdate(event) {
      this.$emit('updatedInput', event.target.value)
    },
    handleDateUpdateFromCalendar(value) {
      this.$emit('updatedCalendar', value)
      this.datePickerMenu = false
      this.$refs.filterDate.blur()
    },
  },
}
</script>

<template>
  <section>
    <v-text-field
      ref="filterDate"
      data-testid="client-group-overview-date-filter-input"
      :value="filterDate"
      :loading="loading"
      :disabled="loading"
      outlined
      :class="['unstyled', isMediumOrHigher ? 'ml-4' : 'mt-4']"
      type="date"
      append-icon="mdi-calendar"
      :rules="[validDateRule]"
      @click:append="show"
      @keyup.native.enter="handleDateUpdate"
      @blur="handleDateUpdate"
    >
    </v-text-field>

    <v-menu
      v-model="datePickerMenu"
      :close-on-content-click="false"
      transition="scale-transition"
      max-width="290px"
      min-width="290px"
      :position-x="x"
      :position-y="y"
      absolute
    >
      <v-date-picker
        data-testid="client-group-overview-date-filter-calendar-picker"
        :value="filterDate"
        :locale="$i18n.locale"
        no-title
        @change="handleDateUpdateFromCalendar"
      >
      </v-date-picker>
    </v-menu>
  </section>
</template>

<style lang="scss" module>
// Hides default calendar picker icon and calendar
::-webkit-calendar-picker-indicator {
  display: none !important;
}
</style>
